import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { Form } from "@unform/web";
import { toast } from "react-toastify";
import FormHeader from "~/components/RegisterForm/FormHeader";
import Input from "~/components/RegisterForm/Input";
import InputLine from "~/components/RegisterForm/InputLine";
import InputLineGroup from "~/components/RegisterForm/InputLineGroup";
import Preview from "~/components/Preview";
import FormLoading from "~/components/RegisterForm/FormLoading";
import { errorMessage } from "~/components/SupportChat/tickets";
import api from "~/services/api";
import { FullGridContext } from "../..";
import ApproverSlots, { useApproverSlots } from "./Approvers";

export const DefaultsContext = createContext({});

export default function Defaults({ access }) {
  const { handleOpened, successfullyUpdated, setSuccessfullyUpdated } = useContext(FullGridContext);
  const generalForm = useRef();
  const [fullscreen, setFullscreen] = useState(false);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const approvers = useApproverSlots();

  useEffect(() => {
    setSuccessfullyUpdated(true);
    api
      .get("/tickets/settings")
      .then(({ data }) => {
        setSettings(data);
        approvers.fill(data.approvers);
      })
      .catch((e) => toast.error(errorMessage(e)));
  }, []);

  function handleCloseForm() {
    if (!successfullyUpdated) toast("Changes discarted!", { autoClose: 1000 });
    handleOpened(null);
  }

  async function handleSubmit(data) {
    if (successfullyUpdated) {
      toast("No need to be saved!", { autoClose: 1000, type: "info" });
      return;
    }
    setLoading(true);
    try {
      await api.put("/tickets/settings", {
        user_ids: approvers.ids(),
        bug_required_approvals: Number(data.bug_required_approvals),
        feature_required_approvals: Number(data.feature_required_approvals),
      });
      setSuccessfullyUpdated(true);
      toast("Saved!", { autoClose: 1000 });
      handleOpened(null);
    } catch (e) {
      toast.error(errorMessage(e));
      setLoading(false);
    }
  }

  return (
    <Preview formType="full" fullscreen={fullscreen}>
      <div className="border h-full rounded-xl overflow-hidden flex flex-1 flex-col justify-start">
        <div className="flex flex-col items-start justify-start text-sm overflow-y-scroll">
          {!settings ? (
            <FormLoading />
          ) : (
            <Form ref={generalForm} onSubmit={handleSubmit} className="w-full">
              <DefaultsContext.Provider value={{ id: "defaults", generalForm, setSuccessfullyUpdated, fullscreen, setFullscreen, successfullyUpdated, handleCloseForm, canceled: null }}>
                <FormHeader access={access} title="Default approvers" InputContext={DefaultsContext} loading={loading} />
                <InputLineGroup title="Rules" activeMenu>
                  <InputLine title="Approvals needed" subtitle="How many approvers must approve before a ticket moves forward. Used when the ticket does not choose its own number.">
                    <Input type="number" name="bug_required_approvals" title="Bug" min={1} max={10} required defaultValue={settings.bug_required_approvals} InputContext={DefaultsContext} />
                    <Input type="number" name="feature_required_approvals" title="Feature" min={1} max={10} required defaultValue={settings.feature_required_approvals} InputContext={DefaultsContext} />
                  </InputLine>
                  <InputLine title="Default approvers" subtitle="They vote on tickets that have no approvers picked on them, like the ones opened from the chatbot." />
                  <ApproverSlots state={approvers} InputContext={DefaultsContext} />
                </InputLineGroup>
              </DefaultsContext.Provider>
            </Form>
          )}
        </div>
      </div>
    </Preview>
  );
}
